export default __webpack_public_path__ + "static/media/review-survey.d2edca01.svg";